import React from 'react';
import styled, { css } from 'styled-components';

import { placeholderAnimationCss } from '@tager/web-components';

import { media } from '@/utils/mixin';

function PreviewSpecificationPlaceholder() {
  return (
    <Component>
      <PreviewItem>
        <ItemIcon />
        <ItemContent>
          <ContentTitle />
          <ContentSubtitle />
        </ItemContent>
      </PreviewItem>
      <PreviewItem>
        <ItemIcon />
        <ItemContent>
          <ContentTitle />
          <ContentSubtitle />
        </ItemContent>
      </PreviewItem>
      <PreviewItem>
        <ItemIcon />
        <ItemContent>
          <ContentTitle />
          <ContentSubtitle />
        </ItemContent>
      </PreviewItem>
      <PreviewItem>
        <ItemIcon />
        <ItemContent>
          <ContentTitle />
          <ContentSubtitle />
        </ItemContent>
      </PreviewItem>
    </Component>
  );
}

export default PreviewSpecificationPlaceholder;

const Component = styled.div`
  margin-top: 40px;
  display: flex;

  ${media.mobile(css`
    flex-direction: column;
    margin-top: 30px;
    margin-left: 10px;
  `)}
`;

const PreviewItem = styled.div`
  display: flex;
  margin-right: 15px;

  ${media.mobile(css`
    &:not(:last-child) {
      margin-bottom: 20px;
    }
  `)}
`;

const ItemIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  margin-right: 5px;
  ${placeholderAnimationCss};
`;

const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ContentTitle = styled.div`
  height: 16px;
  width: 50px;
  border-radius: 8px;
  ${placeholderAnimationCss};
`;

const ContentSubtitle = styled.div`
  height: 24px;
  width: 100px;
  border-radius: 8px;
  ${placeholderAnimationCss};
`;
